// tslint:disable
function n(n: any) {
  const t = parseFloat(n);
  const p = !isNaN(t);
  return p && t.toString() === n
    ? {
        type: "number",
        value: parseFloat(n)
      }
    : p && t.toString() !== n
    ? {
        type: "string",
        value: n
      }
    : '"' === n[0] && '"' === n.slice(-1)
    ? {
        type: "string",
        value: n.slice(1, -1)
      }
    : {
        type: "identifier",
        value: n
      };
}

function t(p: any, c?: any): any {
  if (void 0 === c) {
    return t(p, []);
  }
  {
    const u = p.shift();
    return void 0 === u
      ? c.pop()
      : "(" === u
      ? (c.push(t(p, [])), t(p, c))
      : ")" === u
      ? c
      : t(p, c.concat(n(u)));
  }
}
function p(n: any): any {
  return n
    .replace(/\\"/g, "!escapedquote!")
    .split('"')
    .map(function(n: any, t: any) {
      return t % 2 == 0
        ? n
            .replace(/\(/g, " ( ")
            .replace(/\)/g, " ) ")
            .replace(/,/g, "")
        : JSON.parse(
            `"${n
              .replace(/ /g, "!whitespace!")
              .replace(/\\\\\\\\u00a0/g, "!nbsp4!")
              .replace(/\\u00a0/g, "!nbsp1!")
              .replace(/\\n/g, "!newline!")}"`
          );
    })
    .join('"')
    .trim()
    .split(/\s+/)
    .map(function(n: any) {
      return n
        .replace(/!whitespace!/g, " ")
        .replace(/!nbsp4!/g, "\\\\u00a0")
        .replace(/!nbsp1!/g, " ")
        .replace(/!newline!/g, "\n")
        .replace(/!escapedquote!/g, '"');
    });
}
const parseTree = function(n: any) {
  return t(p(n));
};
export default parseTree;
